'use client';

import Layout from '../../components/Layout';
import SubDocsLayout from '../../components/SubDocsLayout';
import useTranslation from '../../lib/translation';
import SEOHead from '../../components/SEOHead';

const servicesList = [
  { titleKey: 'services.webDevelopment.title', descKey: 'services.webDevelopment.desc', enTitle: 'Custom website development', enDesc: 'Fast, scalable sites using Next.js, Firebase, and modern tech.' },
  { titleKey: 'services.seo.title', descKey: 'services.seo.desc', enTitle: 'SEO optimization', enDesc: 'Your website is built to rank on Google from day one.' },
  { titleKey: 'services.cms.title', descKey: 'services.cms.desc', enTitle: 'Graphic & UI design', enDesc: 'Elegant, professional visuals tailored to your brand.' },
  { titleKey: 'services.hosting.title', descKey: 'services.hosting.desc', enTitle: 'Mobile-first approach', enDesc: 'Responsive layouts that work beautifully on any screen.' },
  { titleKey: 'services.maintenance.title', descKey: 'services.maintenance.desc', enTitle: 'Hosting & domain setup', enDesc: 'We take care of everything — hosting, SSL, and domain management.' },
  { titleKey: 'cmsAdmin', descKey: 'cmsAdminDesc', enTitle: 'CMS & admin tools', enDesc: 'Easily update your site with our included content manager.' },
];

const Services = () => {
  const { t, lang } = useTranslation('common');

  return (
    <Layout>
      <SEOHead
        title={
          lang === 'lt' ? Array.isArray(t('services.pageTitle')) ? (t('services.pageTitle') as string[]).join(' ') : (t('services.pageTitle') as string) : 'Services | LB Websites'
        }
        description={
          lang === 'lt'
            ? Array.isArray(t('services.description')) ? (t('services.description') as string[]).join(' ') : (t('services.description') as string)
            : 'Explore LB Websites services — custom websites, SEO, design, hosting, and full CMS included.'
        }
        keywords='website development, web design, SEO, CMS, custom websites, digital services, LB Websites services'
        canonicalUrl={lang === 'lt' ? '/lt/sub/paslaugos' : '/sub/services'}
        lang={lang}
        structuredData={{
          '@context': 'https://schema.org',
          '@type': 'Service',
          name:
            lang === 'lt' ? Array.isArray(t('services.pageTitle')) ? (t('services.pageTitle') as string[]).join(' ') : (t('services.pageTitle') as string) : 'Services | LB Websites',
          description:
            lang === 'lt'
              ? Array.isArray(t('services.description')) ? (t('services.description') as string[]).join(' ') : (t('services.description') as string)
              : 'Explore LB Websites services — custom websites, SEO, design, hosting, and full CMS included.',
          url: `https://www.lbvisible.com${
            lang === 'lt' ? '/lt/sub/paslaugos' : '/sub/services'
          }`,
          inLanguage: lang === 'lt' ? 'lt' : 'en',
          provider: {
            '@type': 'Organization',
            name: 'LB Visible',
          },
        }}
      />

      <SubDocsLayout>
        <h1 className='text-2xl sm:text-3xl font-semibold text-gray-900 dark:text-white mb-4 text-left'>
          {lang === 'lt' ? t('services.heading') : 'Services'}
        </h1>
        <p className='text-base text-gray-600 dark:text-gray-300 mb-10 text-left leading-relaxed'>
          {lang === 'lt'
            ? t('services.subtitle')
            : 'We deliver full-stack website solutions with everything your business needs — from development to launch, and beyond.'}
        </p>

        <ul className='space-y-6'>
          {servicesList.map((item) => (
            <li key={item.titleKey} className='flex gap-4'>
              <span className='flex-shrink-0 w-2 h-2 rounded-full mt-2 bg-gray-400 dark:bg-gray-500' />
              <div>
                <h2 className='font-semibold text-gray-900 dark:text-white mb-1.5'>
                  {item.titleKey === 'cmsAdmin' ? (lang === 'lt' ? 'TVS ir administravimo įrankiai' : item.enTitle) : (lang === 'lt' ? t(item.titleKey) : item.enTitle)}
                </h2>
                <p className='text-sm text-gray-600 dark:text-gray-400 leading-relaxed'>
                  {item.descKey === 'cmsAdminDesc' ? (lang === 'lt' ? "Lengvai atnaujinkite savo svetainę su mūsų įtrauktu turinio valdytoju." : item.enDesc) : (lang === 'lt' ? t(item.descKey) : item.enDesc)}
                </p>
              </div>
            </li>
          ))}
        </ul>
      </SubDocsLayout>
    </Layout>
  );
};

export default Services;
